<template>
    <modal 
        v-if="isModal" 
        printButton
        downloadButton
        :close="close" 
        :printStyle="style" 
        :title="'Онлайн-проверка адреса'" 
        :pdfFileName="`CheckAddress_${address}`"
    >
        <h3 slot="modalHeader"><b>Онлайн-проверка адреса</b></h3>
        <div class="content" slot="modalBody">
            <addressCheckPDF :data="data_result" :date="date" :address="address" />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import addressCheckPDF from './addressCheckPDF.vue'

export default {
    components: { modal, addressCheckPDF},
    computed: {
        date() { return this.data?.date?.slice(0, 10) ?? new Date().toLocaleDateString()},
        isModal() { return this.$store.state?.addressCheck?.isModal },
        data_result() { return this.$store.state?.addressCheck?.data?.searched_result },
        data() { return this.$store.state?.addressCheck?.data },
        region() { return this.data?.request_params?.region_title },
        city() { return this.data?.request_params?.city },
        street() { return this.data?.request_params?.street },
        house() { return this.data?.request_params?.house },
        build() { return this.data?.request_params?.build },
        flat() { return this.data?.request_params?.flat },
        style() { return this.$store.state.addressCheck.pdfStyle },
        address() { return `${this.region ? `${this.region}` : ''}${this.city ? `, г. ${this.city}` : ''}${this.street ? `, ул. ${this.street}` : ''}${this.house ? `, д. ${this.house}` : ''}${this.build ? `, к. ${this.build}` : ''}${this.flat ? `, кв/оф ${this.flat}` : ''}` }
    },
    methods: {
        close() { this.$store.commit('addressCheck/toggleModal', false) }
    }
}
</script>

<style lang="sass" scoped>
    .content
        padding: 5px 15px
</style>